"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-aluminum-extrusion";
const IMAGE_BASE = "/image/new-version/more/AluminumExtrusion";

export default function AluminumExtrusionServices() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-center text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("servicesTitle")}
				</h2>

				<div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12">
					<div className="relative aspect-[16/9] w-full overflow-hidden bg-[#f5f7fa]">
						<Image
							src={`${IMAGE_BASE}/js-precision-aluminum-extrusion-services.webp`}
							alt={t("servicesImageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 50vw"
						/>
					</div>

					<div className="space-y-5 text-sm text-black md:text-base md:leading-[1.8]">
						<p>{t("servicesDesc1")}</p>
						<p>
							{t("servicesDesc2Before")}
							<strong className="font-bold">{t("servicesDesc2Bold")}</strong>
							{t("servicesDesc2After")}
						</p>
						<p>
							{t("servicesDesc3Before")}
							<strong className="font-bold">{t("servicesDesc3Bold")}</strong>
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}
